import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import urljoin from 'url-join'

import './index.css'
import favicon from '../favicon.png'
import Omt from '../components/omt'
import Footer from '../components/footer'
import { siteUrl } from '../config'
import card from '../img/card.png'
import cardTwitter from '../img/card-twitter.png'

const Layout = ({ children, data }) => {
  return (
    <div>
      <Helmet
        title={data.site.siteMetadata.title}
        meta={[
          {
            name: 'description',
            content:
              'Rapport - Give focus to your team meetings or agile retrospectives',
          },
          {
            name: 'keywords',
            content: 'rapport, meeting, agile retrospective, retro',
          },
        ]}
      >
        <link rel="icon" type="image/png" href={favicon} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@rapportapp" />
        <meta name="twitter:creator" content="@rapportapp" />
        <meta name="twitter:image" content={urljoin(siteUrl, cardTwitter)} />
        <meta property="og:title" content="Rapport" />
        <meta property="og:url" content={siteUrl} />
        <meta
          property="og:description"
          content="Give focus to your team meetings or agile retrospectives"
        />
        <meta property="og:site_name" content="Rapport" />
        <meta property="og:image" content={urljoin(siteUrl, card)} />
        <meta
          name="google-site-verification"
          content="rOuLCVc1yRUQjSm6syP5V6qbva14asKIiOAL4dbB4TI"
        />
      </Helmet>
      {children()}
      <Omt />
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js